import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import url from '../../../../../helpers/url';
import { getData } from '../../../../../helpers/request';
import moment from 'moment';
import { Viewer } from "../../../../widgets/Viewer";
import { withRouter } from 'react-router-dom';

class ReceivedDonationsView extends Component {
    state = {
        donationsReceived: null
    }
    componentDidMount() {
        this.loadData();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.clientId !== this.props.match.params.clientId) {
            this.loadData(nextProps);
        }
    }
    loadData = async (props = this.props) => {
        const { params: { clientId }} = props.match;
        
        const result = await getData({
            url: url.recipientDonations.replace(':recipientId', clientId)
        });
        const { success, data } = result;
        if (success) {
            this.setState({ donationsReceived: data });
        } else {
            this.setState({ donationsReceived: null });
        }
    }
    render() {
        const { donationsReceived } = this.state;
        const { params: { clientId }} = this.props.match;
        const { recipientsById } = this.props.recipientState;
        const { donorsById } = this.props.donorState;
        const currentRecipient = recipientsById[clientId];

        if (!donationsReceived) { 
            return null;
        }
        
        const currentDonor = donorsById[currentRecipient.assigned_donor_id];
        const currentDonorName = currentDonor ? `${currentDonor.first_name} ${currentDonor.middle_name} ${currentDonor.last_name}` : 'None'
     
        return (
            <Fragment>
                <div className="panel-title">
                    <span className="panel-title-flex">
                        <h4>Received Donations</h4>
                    </span>
                </div>
                <div className="panel-donation">
                    <div className="current-donor-row">
                        <span>Current Donor:</span>{currentDonorName}
                    </div>
                    { donationsReceived && donationsReceived.length > 0 ?
                        <table className="general-table pt-html-table">
                            <thead>
                                <tr>
                                    <th>Donor</th>
                                    <th>Amount</th>
                                    <th>Donated Date</th>
                                    <th>Notes</th>
                                    <th>Preview</th>
                                </tr>
                            </thead>
                            <tbody>
                                { donationsReceived.map((donationReceived, i) => {
                                    const donor = donorsById[donationReceived.donor_id];
                                    const donorName = donor ? `${donor.first_name} ${donor.middle_name} ${donor.last_name}` : 'N/A'
                                    return (
                                        <tr key={i}>
                                            <td>{donorName}</td>
                                            <td>${donationReceived.amount} ({donationReceived.currency})</td>
                                            <td>{moment(donationReceived.donation_date).format('ddd, MMM Do, YYYY')}</td>
                                            <td>{donationReceived.notes}</td>
                                            <td onClick={e => e.stopPropagation()}>
                                            <Viewer src={donationReceived.image || donationReceived.dropbox_image_share_url || ''} style={{ height: '30px' }} thumbnail />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table> : null
                    }
                </div>
            </Fragment>
            
        );
    }
}

export default withRouter(connect(
    (state) => ({
        donorState: state.donor,
    }),
    { }
)(ReceivedDonationsView));



// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/ReceivedDonationsView.jsx